import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { DocumentListItem } from "../../../../../../shared/document/chase-document-list/document-list-item.model";
import { ChaseDocumentService } from "../../../chase-document.service";

@Component({
  selector: "member-chase-detail-info-chart",
  templateUrl: "./chase-detail-info-chart.component.html",
  styleUrls: ["./chase-detail-info-chart.component.scss"],
  providers: [ChaseDocumentService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChaseDetailInfoChartComponent implements OnInit {
  documentListItem: DocumentListItem;
  chartImageString = "";
  numberOfPages = 0;


  constructor(
    private service: ChaseDocumentService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    const chaseId = this.service.getChaseGdFromPath();
    this.service
      .getChasePreview(chaseId)
      .subscribe(this.assignAndNotifyListDocumentItems);
  }


  private assignAndNotifyListDocumentItems = (data: DocumentListItem): void => {
    if (data != null) {
      this.documentListItem = data;
      this.chartImageString = this.documentListItem.image;
      this.numberOfPages = this.documentListItem.documentNumberOfPages;
      this.changeDetector.markForCheck();
    }
  }
}
